module.exports = __webpack_public_path__ + "img/soy-organizacion_banner_1.90261991.webp";